<div
  *ngIf="visible"
  class="eva-drawer-container"
  [class.eva-drawer-container--visible]="visible"
  [style.z-index]="currentZIndex"
>
  <!-- Backdrop -->
  <div *ngIf="modal" class="eva-drawer__backdrop" (click)="onBackdropClick()"></div>

  <!-- Drawer -->
  <div
    class="eva-drawer"
    [class.eva-drawer--left]="position === 'left'"
    [class.eva-drawer--right]="position === 'right'"
    [class.eva-drawer--top]="position === 'top'"
    [class.eva-drawer--bottom]="position === 'bottom'"
    [class.eva-drawer--visible]="visible"
    [ngStyle]="drawerStyle"
    [ngClass]="styleClass"
    role="dialog"
    aria-modal="true"
  >
    <!-- Header -->
    <div *ngIf="header || showClose" class="eva-drawer__header">
      <div class="eva-drawer__header-content">
        <h3 *ngIf="header" class="eva-drawer__title">{{ header }}</h3>
        <p *ngIf="subtitle" class="eva-drawer__subtitle">{{ subtitle }}</p>
      </div>
      <button *ngIf="showClose" type="button" class="eva-drawer__close" (click)="hide()" aria-label="Fermer">
        <ng-icon name="heroXMark"></ng-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="eva-drawer__content">
      <ng-content></ng-content>
    </div>

    <!-- Footer (projected) -->
    <div class="eva-drawer__footer">
      <ng-content select="[drawer-footer]"></ng-content>
    </div>
  </div>
</div>
